import {
    SetSessionModal
  } from 'one-state-setsession/src/setsessionModal';
import {format} from 'one-util-date';  
/**
 * This Function transforms the backend response
 * in the Data Model that supports the
 * Active Problems Component
 * @param response has the backend
 * pcp response
 * @param context has settings etc..
 */


export const TransformResponse = (response: any, context: any) => {
    /**
     * @param result contains the transformed response
     */
    // let result: ActiveProblems[] = [];
   
    let result :any = {
        setsessionkey:[],
        error:undefined
    }
    const { log } = context;
    // TODO:verify backend team check for errors
    if (response && response.status >= 400) {
        result.error=response;
    
     }
   
    if (response && response.length > 0) {
        const rs = response;
        let setsessionprobs:SetSessionModal[]=[]
        rs.map((ele: any) => {
            let setsessionobj:SetSessionModal ={
                created_key :"",
            }
            setsessionobj.created_key = ele.created_key;

            setsessionprobs.push(setsessionobj);
        });
        result.setsessionkey=setsessionprobs;
    }
    log.debug(
        "ccw-gadget,setsession-epic",
        "setsession-epic transforamtion response ", {
        result
    });
    return result;
}